import React, { Component } from "react";
import {
  Row,
  Alert,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";
import { DatePicker } from "../../Shared/Forms/DateTimePicker";

class MerchantLocationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false
    };
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    this.props.submitAction(data);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.resetForm();
    }
  }

  resetForm = () => {
    this.refs.merchLocationForm.reset();
  };

  reset = () => {
    this.props.reset();
    this.resetForm();
  };

  render() {
    const { canSubmit } = this.state;
    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      isView,
      fetchingRow,
      fetchingError,
    } = this.props;

    
    return (
      <div>
        <Row>
          <Col>
            <Card>
              <CardHeader>{hasParams ? "Edit" : "Create"} Merchant Location</CardHeader>
              <CardBody>
                {error && !error.errors ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                {error && error.errors && error.errors.length ? (
                  <UncontrolledAlert color="danger">
                    {error.errors.map((error, index) => (
                      <p key={index}>{error.message}</p>
                    ))}
                  </UncontrolledAlert>
                ) : null}
                {fetchingError ? (
                  <UncontrolledAlert color="danger">
                    {fetchingError.message}
                  </UncontrolledAlert>
                ) : null}

                {fetchingRow && (
                  <Alert color="info">
                    <Spinner message="Fetching ads details" />
                  </Alert>
                )}
                <Formsy
                  ref="bannerForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="title"
                    value={selectedRow && hasParams ? selectedRow.title : null}
                    required
                    disabled={submitting || isView || fetchingRow}
                    title="Title"
                    validations={{
                      minLength: 3,
                      maxLength: 50
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />

                  <TextInput
                    name="description"
                    type="textarea"
                    required
                    value={
                      hasParams && selectedRow ? selectedRow.description : null
                    }
                    disabled={submitting || isView || fetchingRow}
                    title="Description"
                    validations={{
                      minLength: 5
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />
                  <DatePicker
                    name="endAt"
                    required
                    label="Expiry Date"
                    title="Expiry Date"
                    minDate={new Date()}
                    isTime={true}
                    disabled={submitting || isView || fetchingRow}
                    defaultValue={hasParams && selectedRow && selectedRow.endAt}
                    innerRef={c => {
                      this.endAt = c;
                    }}
                  />
                  <TextInput
                    name="actionLink"
                    value={
                      selectedRow && hasParams ? selectedRow.actionLink : null
                    }
                    subtitle="
( Example:http://www.example.com )"
                    type="url"
                    disabled={submitting || isView || fetchingRow}
                    title="Link"
                    validations={{
                      minLength: 3
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed"
                    }}
                  />

                  {!hasParams ? (
                    <Button
                      type="submit"
                      color="primary"
                      disabled={!canSubmit || submitting || isView}
                      className="pp3"
                    >
                      {submitting ? (
                        <Spinner size="sm" />
                      ) : (
                        <span>
                          <MdAdd size={20} />
                          Create
                        </span>
                      )}
                    </Button>
                  ) : null}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.reset()}
                      className="mr-1"
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default MerchantLocationForm;
